import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, X } from 'lucide-react';

const TestFlowModal = ({ isOpen, onClose, results }) => {
  if (!isOpen || !results) return null;

  const { valid, errors = [], warnings = [] } = results;
  const allClear = valid && warnings.length === 0;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4">
        <div className="flex items-center justify-between p-5 border-b border-gray-100">
          <div className="flex items-center gap-3">
            {allClear ? (
              <CheckCircle size={22} className="text-green-500" />
            ) : errors.length > 0 ? (
              <XCircle size={22} className="text-red-500" />
            ) : (
              <AlertTriangle size={22} className="text-yellow-500" />
            )}
            <h2 className="text-base font-semibold text-gray-900">Test Flow Results</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <X size={18} />
          </button>
        </div>

        <div className="p-5 space-y-4 max-h-[60vh] overflow-y-auto">
          {allClear && (
            <div className="flex items-center gap-3 p-4 bg-green-50 border border-green-200 rounded-lg">
              <CheckCircle size={18} className="text-green-600 flex-shrink-0" />
              <div>
                <div className="font-medium text-green-800">Flow is valid</div>
                <div className="text-sm text-green-600">No errors or warnings found.</div>
              </div>
            </div>
          )}

          {errors.length > 0 && (
            <div>
              <div className="flex items-center gap-2 mb-2">
                <XCircle size={15} className="text-red-500" />
                <span className="text-sm font-semibold text-red-700">Errors ({errors.length})</span>
              </div>
              <ul className="space-y-2">
                {errors.map((err, i) => (
                  <li key={i} className="flex items-start gap-2 p-3 bg-red-50 border border-red-100 rounded-lg text-sm text-red-800">
                    <XCircle size={14} className="text-red-400 mt-0.5 flex-shrink-0" />
                    {err}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {warnings.length > 0 && (
            <div>
              <div className="flex items-center gap-2 mb-2">
                <AlertTriangle size={15} className="text-yellow-500" />
                <span className="text-sm font-semibold text-yellow-700">Warnings ({warnings.length})</span>
              </div>
              <ul className="space-y-2">
                {warnings.map((w, i) => (
                  <li key={i} className="flex items-start gap-2 p-3 bg-yellow-50 border border-yellow-100 rounded-lg text-sm text-yellow-800">
                    <AlertTriangle size={14} className="text-yellow-400 mt-0.5 flex-shrink-0" />
                    {w}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="flex justify-end p-4 border-t border-gray-100">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg bg-gray-900 text-white hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestFlowModal;
